<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#barrier"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title">Редактирование временно недоступно</div>

              <p class="info-text">
                  В данный момент это правило редактирует<br>
                  <span class="text-bold">{{blockEdit.user.lastName}} {{blockEdit.user.name}}, {{blockEdit.user.phone}}</span><br>
                  Дождитесь окончания редактирования...
              </p>
          </div>

          <div class="mt24">
              <span class="btn btn--ico" @click="close">Понятно</span>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "EditDisabled",
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.editDisabled.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
            }),
            blockEdit(){
                return (this.$route.name === 'moderator-contract' || this.$route.name === 'moderator-contract-detail')?this.$store.state.contracts.blockEdit:this.$store.state.rules.blockEdit
            }
        }
    }
</script>

<style scoped>

</style>
